interface INetworkErrorType {
  code: number;
  message: string;
  tag?: string;
  extInfo?: string;
}

export class NetworkError extends Error {
  code = 0;
  message = '';
  tag = '';
  extInfo = '';
  constructor({ code, message, tag, extInfo }: INetworkErrorType) {
    super();
    this.code = code;
    this.message = message;
    this.tag = tag || '';
    this.extInfo = extInfo || '';
  }
}
